import Axios from "axios";

export const BASE_URL = "http://m.ubook.red/wx/";
// export const BASE_URL = "http://zll-nb:8080/wx/";

export const APPID = "wxc65acbb276063420";

export const wxLogin = (appid, url) => {
	let redirect_uri = encodeURIComponent(url);
	window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`;
};
// 获取url上的参数
export const getUrlParam = (name) => {
	let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
	let r = window.location.search.substr(1).match(reg); //匹配目标参数
	if (r != null) return decodeURIComponent(r[2]);
	return null; //返回参数值
};

export const Get = (url, params, s, f) => {
	Axios.get(BASE_URL + url, {
		params: params,
	})
		.then(s)
		.catch(f);
};

export const Post = (url, params, s, f) => {
	Axios.post(
		BASE_URL + url,
		{
			// params: params,
		},
		{
			data: params,
			transformRequest: [
				function(data) {
					// Do whatever you want to transform the data
					let ret = "";
					for (let it in data) {
						ret +=
							encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
					}
					return ret;
				},
			],
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
			},
		}
	)
		.then(s)
		.catch(f);
};

export const WxLogin = (url) => {
	let redirect_uri = encodeURIComponent(url);
	window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`;
};
